import Button from './button';
import ButtonGroup from '../button/button-group';

const components = [Button, ButtonGroup];
components.forEach((item) => {
  item.install = function (Vue) {
    Vue.component(item.name, item);
  };
});

export { Button, ButtonGroup };
